module.exports = __webpack_public_path__ + "static/media/Screenshot_4-thumb.3ab90a21.png";